import React from "react";
import "../../resources/css/application.css";
import logoWhite from "../../resources/images/logo-white.svg";

const Header = (props) => {

  const {headerTextFlag} = props;

  return (
    <div>

      <header className="site-header">

        <a className="skip-link sr-only sr-only-focusable" href="#site-content">Preskoči na sadržaj</a>

        <div className="container d-flex flex-column">

          <a href="https://www.otpbanka.hr/" className="site-logo" title="OTP banka d.d.">
            <img alt={""} src={logoWhite}/>
          </a>

          <div className="hero" id="site-content">

            <div className="row">
              <div className="col-lg-7">
                <h1 className="hero__headline">Ažuriranje studentskog statusa</h1>
                {headerTextFlag !== false && <p className="hero__subheadline">Svoj studentski status možeš ažurirati pomoću forme na ovoj stranici</p>}
              </div>
            </div>

          </div>

        </div>

      </header>
    </div>

  );
};

export default Header;
